export const TokenName = process.env.NODE_ENV !== 'production' ? 'local-pay-token' : process.env.RUN_ENV === 'test' ? 'kopglobal-test-token' : 'kopglobal-pay-token'
export const LangName = process.env.NODE_ENV !== 'production' ? 'local-pay-lang' : 'kopglobal-pay-lang'
// todo 商城的 token目前先用 企业官网的
export const SiteTokenName = 'site-token' // 'site-token'

export const PlaceCookie = 'place-cookie'
